<template>
    <div v-if="order" class="order-detail">
        <h1>Order Details</h1>

        <div class="summary-container">
            <section class="order-summary">
                <h2>Order Summary</h2>
                <ul>
                    <li><strong>Order ID:</strong> {{ order.shopify_order_number }}</li>
                    <li><strong>Order Date:</strong> {{ order.createdAt }}</li>
                    <li><strong>Total Amount:</strong> {{ order.total_price }}rs</li>
                    <li><strong>Tracking Number: </strong>{{ order.order_delivery?.cn }}</li>
                    <li><strong>Delivery Status: </strong>{{ tracking }}</li>
                </ul>
            </section>

            <section class="customer-info">
                <h2>Customer Information</h2>
                <ul>
                    <li><strong>Name:</strong> {{ order.order_billing.first_name }} {{ order.order_billing.last_name }}
                    </li>
                    <li><strong>Email:</strong> {{ order.email }}</li>
                    <li><strong>Phone:</strong> {{ order.order_billing.phone }}</li>
                    <li><strong>Address:</strong> {{ order.order_billing.address1 }}</li>
                </ul>
            </section>
        </div>

        <section class="product-info">
            <h2>Product Information</h2>
            <table>
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="product in order.order_products" :key="product.id">
                        <td>{{ product.title }}</td>
                        <td>{{ product.quantity }}</td>
                        <td>{{ product.price }}rs</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <section class="chatbox">
            <h2>Chatbox</h2>
            <div class="messages">
                <div v-for="message in chatMessages" :key="message.id" class="message">
                    <strong>{{ message.sent_by }}:</strong> {{ message.message }}
                    <div class="timestamp">{{ formatDate(message.createdAt) }}</div>
                </div>
            </div>
            <form @submit.prevent="sendMessage">
                <input v-model="newMessage" type="text" placeholder="Type your message..." />
                <button type="submit">Send</button>
            </form>
            <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import {jwtDecode} from "jwt-decode";

export default {
    name: "OrderDetail",
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            options: {
                headers: {
                    "Access-Control-Allow-Headers":
                        "X-Custom-Header, Access-Control-Request-Headers",
                    "x-access-token": localStorage.getItem("token"),
                    //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
                },
            },
            order: null,
            chatMessages: [],
            newMessage: "",
            errorMessage: "",
            tracking: "",
            userName: null
        };
    },
    mounted() {
        const token = localStorage.getItem("token"); 

        if (token) {
            const decoded = jwtDecode(token);
            this.userName = decoded.name; 
        }
        let options = {
            headers: {
                "Access-Control-Allow-Headers":
                    "X-Custom-Header, Access-Control-Request-Headers",
                "x-access-token": token,
                //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
            },
        };
        var url = BASE_URL + `orders/getOrder?id=${this.id}`;
        axios
            .get(url, options)
            .then((response) => {
                this.order = response.data
                this.updateMessageStatus()
            })
            .catch((error) => {
                console.log(error);
            });

        var messagesUrl = BASE_URL + `whatsapp/messagesByOrderId?orderId=${this.id}`;
        axios
            .get(messagesUrl, options)
            .then((response) => {
                console.log(response);
                this.chatMessages = response.data.whatsapp_chat_messages
            })
            .catch((error) => {
                console.log(error);
            });

        var trackingURL = BASE_URL + `orders/track?orderId=${this.id}`;
        axios
            .get(trackingURL, options)
            .then((response) => {
                this.tracking = response.data.status
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        sendMessage() {
            if (this.newMessage.trim() !== "") {
                var data = {
                    orderId: this.order.shopify_order_number,
                    message: this.newMessage
                }
                var url = BASE_URL + `whatsapp/sendReply`;
                axios
                    .post(url, data, this.options)
                    .then((response) => {
                        console.log(response)
                        this.chatMessages.push({
                            id: Date.now(),
                            sent_by: this.userName,
                            message: this.newMessage.trim(),
                            createdAt: Date.now()
                        });
                        this.newMessage = "";
                    })
                    .catch((error) => {
                        this.showError(error.response.data)
                    });

            }
        },
        showError(message) {
            this.errorMessage = message;
            setTimeout(() => {
                this.errorMessage = "";
            }, 3000);
        },

        updateMessageStatus() {
            var messagesUrl = BASE_URL + `whatsapp/updateStatus?orderId=${this.id}`;
            axios
                .get(messagesUrl, this.options)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLatestDeliveryStatus(messages) {
            if (!Array.isArray(messages) || messages.length === 0) {
                return null; // no messages available
            }
            const latest = messages
                .filter(m => m && m.createdAt) // ignore null/invalid entries
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
            return latest ? latest.delivery_status : null;
        },
        formatDate(date) {
            const d = new Date(date);
            return d.toLocaleString(); // e.g. "9/25/2025, 10:32 AM"
        }

    },
};
</script>

<style scoped>
.order-detail {
    font-family: Arial, sans-serif;
    margin: 20px;
}

h1,
h2 {
    color: #333;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    margin: 5px 0;
}

section {
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.summary-container {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.order-summary,
.customer-info {
    flex: 1;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

th,
td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

th {
    background-color: #f4f4f4;
}

.chatbox {
    margin-top: 20px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.messages {
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 5px;
}

.message {
    margin-bottom: 5px;
}

form {
    display: flex;
    gap: 10px;
}

input {
    flex: 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

button {
    padding: 8px 12px;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
    cursor: pointer;
}

button:hover {
    background-color: #0056b3;
}

.error-message {
    color: red;
    margin-top: 10px;
    font-size: 14px;
}
.timestamp {
  font-size: 0.75rem;
  color: #777;
  margin-left: 5px;
}
</style>